module.exports = __webpack_public_path__ + "static/media/Niveau_elN2_3_889200.7ae8b628.png";